import { type ReactNode } from "react";

export const MobileContent = ({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: string;
}) => (
  <main
    className={`max-w-screen-xl mx-auto pt-18 px-4 pb-[calc(var(--mobile-navigation-height)+2rem+env(safe-area-inset-bottom))] min-h-dvh ${className}`}
    id="main-content"
  >
    {children}
  </main>
);
